<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.orderNo"
        placeholder="订单编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.deliveryNo"
        placeholder="快递单号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.contact"
        placeholder="联系人(电话、姓名)"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.goodsTitle"
        placeholder="请输入商品名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in ORDER_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.goodsType"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PRODUCT_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
       <el-select
        v-model="listQuery.levelId"
        placeholder="用户类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in userLevelList"
          :key="item.id"
          :label="item.levelName"
          :value="item.id"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="下单开始时间"
        endPlaceholder="下单截止时间"
      />
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="pay"
        startPlaceholder="支付开始时间"
        endPlaceholder="支付截止时间"
      />
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="delivery"
        startPlaceholder="发货开始时间"
        endPlaceholder="发货截止时间"
      />
      <ShopOption
        :refValue="listQuery.shopId"
        class="filter-item"
        type="formShop"
        :styleRef="{ width: '200px' }"
        @valueFunc="getShopValueFunc"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExport"
        style="margin-left: 10px"
        >导出</el-button
      >
    </div>
    <div style="display:flex; align-items: center;">
      <div style="margin-bottom: 5px">订单数量:{{ total }}</div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="userId"
        label="用户会员ID"
        width="190"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="orderNo"
        label="订单编号"
        width="190"
      ></el-table-column>
      <el-table-column
        label="联系姓名"
        align="center"
        prop="name"
        width="100"
      ></el-table-column>
      <el-table-column
        label="联系电话"
        align="center"
        prop="phone"
        width="120"
      ></el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag
            :color="getValue(ORDER_STATUS_CSS, scope.row.status)"
            style="color: #FFFFFF"
            >{{ getValue(ORDER_STATUS, scope.row.status) }} </el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="商品名称"
        prop="title"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
            {{ scope.row.items[0].title }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="售后状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.isAfter ? "售后中" : "未售后" }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="类型"
        prop="goodsType"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ getValue(PRODUCT_TYPE, scope.row.items[0].goodsType) }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="用户类型"
        prop="levelName"
        align="center"
        width="120"
      />
      <el-table-column
        label="支付订单号"
        align="center"
        prop="payNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="支付金额"
        align="center"
        prop="payAmount"
        width="100"
      ></el-table-column>
      <el-table-column
        class-name="status-col"
        label="支付方式"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag>{{
            getValue(ORDER_PAY_PLATFORM, scope.row.payPlatform)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="payTime"
        label="支付时间"
        width="150"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.payTime" />
          <span>{{ formatApiDate(scope.row.payTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="配送类型" align="center">
        <template slot-scope="scope">
          <el-tag
            :color="getValue(ORDER_POSTAGES_TYPE_CSS, scope.row.postagesType)"
            style="color: #FFFFFF"
            >{{ getValue(ORDER_POSTAGES_TYPE, scope.row.postagesType) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="运费金额"
        align="center"
        prop="postagesAmount"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="deliveryTime"
        label="发货时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.deliveryTime" />
          <span>{{ formatApiDate(scope.row.deliveryTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="能否申请售后"
        align="center"
        prop="isAfter"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.isAfter ? 'success' : 'danger'">{{
            scope.row.isAfter ? "能" : "否"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="takeTime"
        label="确认收货时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.takeTime" />
          <span>{{ formatApiDate(scope.row.takeTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="220"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="jumpInfo(scope.row, 'info')"
            class="comm_but_warp"
            >预览</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            @click="
              !scope.row.isAfter && checkShipmentsVisible(true, scope.row)
            "
            class="comm_but_warp"
            :disabled="![2].includes(scope.row.status) || scope.row.isAfter"
            >发货</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    发货-->
    <el-dialog
      title="发货"
      :visible.sync="shipmentsVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="form"
        :rules="goodsFules"
        :model="goodsForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="实物商品" prop="refId">
          <el-table
            ref="multipleTable"
            :data="goodsList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            size="mini"
            v-loading="goodsListLoading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="商品编号" width="80">
            </el-table-column>
            <el-table-column prop="title" label="商品名称"> </el-table-column>
            <el-table-column prop="mainGraph" label="商品图" width="100">
              <template slot-scope="scope">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.mainGraph"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="快递公司" prop="expressld">
          <el-select
            v-model="goodsForm.expressId"
            placeholder="请选择快递公司"
            style="width: 100%"
            class="filter-item"
            clearable
            filterable
          >
            <el-option
              v-for="item in shippingCompanyOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="expressNo">
          <el-input v-model="goodsForm.expressNo" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkShipmentsVisible(false, {})">取消</el-button>
        <el-button
          type="primary"
          @click="shipmentsOk"
          :loading="shipmentsBtnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderList,
  getGoodsList,
  deliveryFeedback,
  exportOrderList,
} from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  ORDER_STATUS,
  ORDER_POSTAGES_TYPE,
  ORDER_PAY_PLATFORM,
  PRODUCT_TYPE
} from "@/utils/enumUtile";
import { getExpress } from "@/api/common";
import {
  ORDER_STATUS_CSS,
  ORDER_POSTAGES_TYPE_CSS,
} from "@/utils/enumUtileCss";
import DataPicker from "@/views/components/dataPicker.vue";
import { uploadXlsx } from "@/utils";
import ShopOption from "@/views/components/shopOption.vue";
import { getUserLevelList } from "@/api/member";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_STATUS() {
      return ORDER_STATUS;
    },
    ORDER_POSTAGES_TYPE() {
      return ORDER_POSTAGES_TYPE;
    },
    ORDER_PAY_PLATFORM() {
      return ORDER_PAY_PLATFORM;
    },
    ORDER_STATUS_CSS() {
      return ORDER_STATUS_CSS;
    },
    ORDER_POSTAGES_TYPE_CSS() {
      return ORDER_POSTAGES_TYPE_CSS;
    },
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    }
  },
  components: { ShopOption, DataPicker },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        orderNo: null,
        deliveryNo: null,
        contact: null,
        goodsType: null,
        goodsTitle: null,
        status: null,
        createStartTime: null,
        createEndTime: null,
        payStartTime: null,
        payEndTime: null,
        deliveryStartTime: null,
        deliveryEndTime: null,
        shopId: null,
      },
      shipmentsVisible: false,
      goodsList: [],
      goodsListLoading: false,
      goodsFules: {
        expressId: [
          { required: true, message: "快递公司不能为空", trigger: "change" },
        ],
        expressNo: [
          { required: true, message: "快递单号不能为空", trigger: "change" },
        ],
      },
      goodsForm: {
        id: 0,
        itemIds: null,
        expressId: null, // 快递公司ID
        expressNo: null, // 快递单号
      },
      shipmentsBtnLoading: false,
      shippingCompanyOption: [], // 发货公司
      userLevelList:[],
    };
  },
  created() {
    const savedState = sessionStorage.getItem("pageState");
    // 只有当 savedState 存在且是有效的 JSON 字符串时才恢复状态
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      // 确保解析后的数据是对象类型
      if (parsedState && typeof parsedState === "object") {
        this.listQuery = { ...this.listQuery, ...parsedState };
      }
    }
    sessionStorage.removeItem("pageState");
    this.getShippingCompany();
    this.getList();
    this.getLevelList();    
  },
  watch: {},
  methods: {
    getValue,
     /**
     * 查询用户等级列表
     */
    getLevelList() {
      getUserLevelList()
        .then(response => {
          this.userLevelList = response.data || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 获取店铺
     * @param type
     * @param resultArr
     */
    getShopValueFunc(type, resultArr) {
      if (type === "formShop") {
        this.listQuery.shopId = resultArr;
      }
    },
    /**
     * 查询发货公司
     */
    getShippingCompany() {
      getExpress().then((resp) => {
        if (resp && resp.bizcode === 100) {
          this.shippingCompanyOption = resp.data;
        }
      });
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form,
      };
      getOrderList(params)
        .then((response) => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 跳转到其他页面
     */
    jumpInfo(item) {
      sessionStorage.setItem("pageState", JSON.stringify(this.listQuery));
      this.$router.push({ path: "/order/list/info/" + item.id });
    },

    // 发货 start
    checkShipmentsVisible(status, item) {
      if (status) {
        this.goodsForm.id = item.id;
        this.getGoodsList(item.id);
      } else {
        this.goodsForm.id = 0;
        this.goodsList = [];
        this.$refs.form.resetFields();
      }
      this.shipmentsVisible = status;
    },
    /**
     * 查询订单详情
     */
    getGoodsList(id) {
      this.goodsListLoading = true;
      const params = {
        id,
      };
      getGoodsList(params)
        .then((resp) => {
          this.goodsList = resp.data;
        })
        .finally(() => {
          this.goodsListLoading = false;
        });
    },
    /**
     * 选择发货商品
     * @param item
     */
    handleSelectionChange(item) {
      this.goodsForm.itemIds = item.map((o) => o.id).join(",");
    },
    shipmentsOk() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const form = this.goodsForm;
          if (!form.itemIds) {
            this.$notify({
              title: "提示",
              message: "请选择需要发货的商品",
              type: "warning",
              duration: 1500,
            });
            return;
          }
          const params = {
            ...form,
          };
          this.shipmentsBtnLoading = true;
          deliveryFeedback(params)
            .then((resp) => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkShipmentsVisible(false);
                this.$notify({
                  title: "成功",
                  message: "发货成功",
                  type: "success",
                  duration: 2000,
                });
              }
            })
            .finally(() => {
              this.shipmentsBtnLoading = false;
            });
        }
      });
    },
    // 发货 end
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.createStartTime = value[0];
        this.listQuery.createEndTime = value[1];
      } else if (type === "pay") {
        this.listQuery.payStartTime = value[0];
        this.listQuery.payEndTime = value[1];
      } else if (type === "delivery") {
        this.listQuery.deliveryStartTime = value[0];
        this.listQuery.deliveryEndTime = value[1];
      }
    },

    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form,
      };
      exportOrderList(params).then((response) => {
        uploadXlsx(response, "订单表");
      });
    },
  },
};
</script>
<style scoped lang="scss">
.comm_but_warp {
  margin-bottom: 10px;
}
.filter-container {
  display: flex;      /* 使用 flex 布局 */
  flex-wrap: wrap;    /* 允许内容换行 */
  align-items: center; /* 垂直居中对齐 */
  gap: 10px;          /* 元素之间的间距（现代浏览器支持） */
  margin-bottom: 20px;
  flex-direction: row;


  // 针对 filter-item 的统一样式
  .filter-item {
    margin-bottom: 0 !important; /* 清除默认的底部边距，由 gap 或容器控制 */
    flex-shrink: 0;             /* 禁止压缩内容长度 */
  }
}

.comm_but_warp {
  margin-bottom: 5px;
}
</style>
